import PropTypes from 'prop-types';
import { useContext } from 'react';
import { RuntimeContext } from '../../../common/RuntimeContext';
import VerbButton, { VERB_BUTTON_TYPE } from '../components/VerbButton';
import VerbHeading from '../components/VerbHeading';
import VerbText from '../components/VerbText';

export default function GenericErrorPage(props) {
    let errorPageHeadingId = 'GENERIC_ERROR_HEADING';
    let errorPageHeading = 'Oops!';
    let errorPageTextId = 'GENERIC_ERROR_TEXT';
    let errorPageText = 'Something went wrong. Please go back and try again.';
    let buttonText = 'TRY AGAIN';
    let buttonClick = () => window.history.back();

    const config = useContext(RuntimeContext);

    if (props.retiredContentError) {
        errorPageHeadingId = 'RETIRED_CONTENT_ERROR_HEADING';
        errorPageHeading = 'Oops!';
        errorPageTextId = 'RETIRED_CONTENT_ERROR_TEXT';
        errorPageText = 'This content is no longer active';
        buttonText = 'GO TO HOME';
        buttonClick = () => window.location.replace(`${config.pathsWeb.clientUrl}/home`);
    }
    return (
        <div className={'generic-error-page'}>
            <img src={'https://res.cloudinary.com/verb-prod/image/upload/v1548710177/verb-error-cat_hwtncs.png'} />
            <div className={'heading-container'}>
                <VerbHeading hNumber={2} messageId={errorPageHeadingId} defaultMessage={errorPageHeading} />
                <div className={'error-text'}>
                    <VerbText messageId={errorPageTextId} defaultMessage={errorPageText} />
                </div>
                <VerbButton
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                    buttonText={buttonText}
                    onClick={buttonClick}
                />
            </div>
        </div>
    );
}

GenericErrorPage.propTypes = {
    retiredContentError: PropTypes.bool
};
